import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";
import { CategoryState } from "../../../entities/Category";

export const getRoot = (state: RootState) => state.category;

export const getCategoriesIsLoading = createSelector(
  [getRoot],
  (category: CategoryState) => category.isLoading,
);

export const getCategoriesData = createSelector(
  [getRoot],
  (category: CategoryState) => category.data,
);

export const getCategories = createSelector(
  [getRoot],
  (category: CategoryState) => category.data.categories,
);
